import { takeLatest, call, put, all } from "redux-saga/effects";
import { actions } from "../NTICore/actionsCreator";
import * as types from "./types";
import * as servicePartner from "./service";

// TODO: WORKER SAGA: MAKES THE API CALL WHEN WATCHER SAGA SEES THE ACTION

/** Set partner agreement model data */
function* setPartnerAgreement(params) {
  if (params) {
    // Sent data to reducer
    yield put(
      actions.success(types.SET_PARTNER_AGREEMENT.SUCCESS, params.payload)
    );
  } else {
    yield put(
      actions.error(
        types.SET_PARTNER_AGREEMENT.ERROR,
        "No partner agreement data was found."
      )
    );
  }
}

/** Set partner agreement model data */
function* sendMessageToPartner(parameters) {
  try {
    yield call(servicePartner.sendMessageToPartner, parameters.payload);

    // Sent data to reducer
    yield put(
      actions.success(
        types.SEND_MESSAGE_TO_PARTNER.SUCCESS,
        "Message has been send successfully to Partner"
      )
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(
      actions.error(
        types.SEND_MESSAGE_TO_PARTNER.ERROR,
        "The agreement has been created successfully but an unexpected error has occurred sending the message to your email, please contact technical support."
      )
    );
  }
}

/** Set partner agreement model data */
function* sendMessageToInternalCEO(parameters) {
  try {
    yield call(servicePartner.sendMessageToInternalCEO, parameters.payload);

    // Sent data to reducer
    yield put(
      actions.success(
        types.SEND_MESSAGE_TO_INTERNAL_CEO.SUCCESS,
        "Message has been send successfully to Internal CEO"
      )
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(actions.error(types.SEND_MESSAGE_TO_PARTNER.ERROR));
  }
}

/** Download PartnerAgreement PDF */
function* downloadPartnerAgreementPDF(params) {
  try {
    const response = yield call(servicePartner.downloadPDF, 45);
    //Successful saving
    if (response) {
      console.log(response);
    } else {
      console.log(response);
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(actions.error(types.DOWNLOAD_AGREEMENT.ERROR, error));
    console.log(error);
  }
}

// TODO: SINGLE ENTRY POINT TO START ALL PARTNER SAFAS AT ONCE
export default function* partnerAgreementRoot() {
  yield all([
    yield takeLatest(types.SET_PARTNER_AGREEMENT.WATCHER, setPartnerAgreement),
    yield takeLatest(
      types.DOWNLOAD_AGREEMENT.WATCHER,
      downloadPartnerAgreementPDF
    ),
    yield takeLatest(
      types.SEND_MESSAGE_TO_PARTNER.WATCHER,
      sendMessageToPartner
    ),
    yield takeLatest(
      types.SEND_MESSAGE_TO_INTERNAL_CEO.WATCHER,
      sendMessageToInternalCEO
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/saga.js